import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <nav class="wc-list-search-summary py-2">
    <small class="wc-list-search-summary-small small d-inline-block me-1 mb-1 shadow-sm rounded-pill">
      <span class="wc-list-search-summary-span-caption bg-primary-subtle p-1 px-2 rounded-start-pill" role="button"></span>
      <span class="wc-list-search-summary-span-clear bg-gray-100 p-1 px-2 rounded-end-pill">
        <a href="#!" class="wc-list-search-summary-a-clear text-orange">
          <i class="wc-list-search-summary-i-clear bi-trash"></i>
        </a>
      </span>
    </small>
  </nav>
`;

export class WCListSearchSummary extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let dataResumo = $$.tool.dataJSON(this.getAttribute('data-resumo'));
    let wcListSearchSummary = clone.content.querySelector('.wc-list-search-summary').cloneNode();
    if (dataResumo.classNameCaption !== null && dataResumo.classNameClear !== null && dataResumo.params.length > 0) {
      dataResumo.params.forEach((param, index) => {
        // let disabled = param.hasOwnProperty('disabled') && param.disabled;
        let wcListSearchSummarySmall = clone.content.querySelector('.wc-list-search-summary-small').cloneNode(false);
        let wcListSearchSummarySpanCaption = clone.content.querySelector('.wc-list-search-summary-span-caption').cloneNode(false);
        let wcListSearchSummarySpanClear = clone.content.querySelector('.wc-list-search-summary-span-clear').cloneNode(false);
        let wcListSearchSummaryAClear = clone.content.querySelector('.wc-list-search-summary-a-clear').cloneNode(false);
        let wcListSearchSummaryIClear = clone.content.querySelector('.wc-list-search-summary-i-clear').cloneNode(false);
        wcListSearchSummarySmall.setAttribute('role', 'button');
        wcListSearchSummaryAClear.setAttribute('href', '#!');
        wcListSearchSummarySpanCaption.classList.add(dataResumo.classNameCaption);
        wcListSearchSummarySpanCaption.setAttribute('data-parametro', param.parametro);
        wcListSearchSummaryAClear.classList.add(dataResumo.classNameClear);
        wcListSearchSummaryAClear.dataset.parametro = param.parametro;
        wcListSearchSummarySpanCaption.append(document.createTextNode(param.caption));
        wcListSearchSummaryAClear.append(wcListSearchSummaryIClear);
        wcListSearchSummarySpanClear.append(wcListSearchSummaryAClear);
        wcListSearchSummarySmall.append(wcListSearchSummarySpanCaption);
        wcListSearchSummarySmall.append(wcListSearchSummarySpanClear);
        wcListSearchSummary.append(wcListSearchSummarySmall);
      });
    }
    this.replaceWith(wcListSearchSummary);

/*
NOTA: Código preservado, para implementar campo fixo (disabled)

    search: {

      preset: null,
      classNameSpan: null,
      classNameA: null,
      params: [],

      summary: function () {
        let summary = [];
        if (this.classNameSpan !== null && this.classNameA !== null && this.params.length > 0) {
          this.params.forEach((param, index) => {
            summary.push(this.param(
              param
            ));
          });
        }
        this.preset = null;
        this.classNameSpan = null;
        this.classNameA = null;
        // this.params = null;
        this.params = [];
        return summary.length > 0 ? $('<div>', {class: 'py-2'}).append(summary) : '';
      },

      param: function (param) {
        let disabled = param.hasOwnProperty('disabled') && param.disabled;
        return $('<small>', {
          class: 'small d-inline-block me-1 mb-1 shadow-sm rounded-pill'
        }).append(
          disabled ?
          $('<span>', {
            class: 'bg-primary-subtle p-1 px-2 rounded-start-pill'
          }).append(param.caption) :
          $('<span>', {
            class: this.classNameSpan + ' bg-primary-subtle p-1 px-2 rounded-start-pill',
            'data-parametro': param.parametro,
            role: 'button'
          }).append(param.caption)
        ).append(
          disabled ?
          $('<span>', {
            class: 'bg-primary p-1 px-2 rounded-end-pill'
          }).append(
            $('<span>', {
              class: 'text-gray-100'
            }).append(
              $('<i>', {class: 'bi-pin'})
            )
          ) :
          $('<span>', {
            class: 'bg-gray-100 p-1 px-2 rounded-end-pill'
          }).append(
            $('<a>', {
              href: '#!',
              class: this.classNameA + ' text-orange',
              'data-parametro': param.parametro
            }).append(
              $('<i>', {class: 'bi-trash'})
            )
          )
        );
      }

    },
*/
  }

}